import { render } from "./ConfirmTattooModal.vue?vue&type=template&id=4f79b81c&scoped=true"
import script from "./ConfirmTattooModal.vue?vue&type=script&lang=js"
export * from "./ConfirmTattooModal.vue?vue&type=script&lang=js"

import "./ConfirmTattooModal.vue?vue&type=style&index=0&id=4f79b81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f79b81c"]])

export default __exports__